import React from 'react';
import '../styles/ChatActionRequired.css';
import { colour } from '../styles/GlobalStyles';
import { Sparkle } from '../assets/icons';
import { Scenario, SelectionChip } from './';
import { renderHTML } from '../functions';

function ChatActionRequired(props) {
    const scenarios = props.scenarios;
    const actionRequired = props.actionRequired;
    const textFinished = props.textFinished;
    const typeOutText = props.typeOutText;
    const selectScenario = props.selectScenario;
    const timeline = props.timeline;
    const darkMode = props.darkMode;
    // const [expanded, setExpanded] = useState(false);

    return (
        scenarios === null ?
        null
        :
        <div className={"chat-action-required-outer-container " + (darkMode === true ? "chat-action-required-dark-mode" : "chat-action-required-light-mode")}>
            <div className="chat-action-required-container">
                <div className="chat-action-required-title-container">
                    <div className="chat-action-required-sparkle-container">
                    <Sparkle
                        fill={darkMode === true ? colour.gray00 : colour.gray06}
                        className="chat-action-required-sparkle"
                        gradient={false}
                    />
                    </div>
                    <div className="chat-action-required-title-text-container">
                        <span className={"body-semibold " + (darkMode === true ? " colour-white" : "colour-primary")}>
                            ACTION REQUIRED
                        </span>
                        <div
                            className={"body-regular " + (darkMode === true ? " colour-white" : "colour-primary") + " typewriter-text-gap"}
                            dangerouslySetInnerHTML={{ __html: renderHTML(scenarios.intro) }}
                        />
                    </div>
                </div>
                <div className="chat-action-required-scenario-row">
                    <Scenario
                        label="Optimistic"
                        scenario={scenarios.optimistic}
                        // expanded={expanded}
                        // setExpanded={setExpanded}
                        typeOutText={typeOutText}
                        textFinished={textFinished}
                        darkMode={darkMode}
                    />
                    <Scenario
                        label="Conservative"
                        scenario={scenarios.conservative}
                        // expanded={expanded}
                        // setExpanded={setExpanded}
                        typeOutText={typeOutText}
                        textFinished={textFinished}
                        darkMode={darkMode}
                    />
                </div>
            </div>
            {
                actionRequired === true &&
                <div className="chat-action-required-chips-container">
                    <div className="chat-action-required-chips-title-container">
                        <div className="chat-action-required-chips-sparkle-container">
                            <Sparkle
                                fill={timeline === true ? colour.gray05 : colour.gray06}
                                className="chat-action-required-chips-sparkle"
                                gradient={false}
                            />
                        </div>
                        <span className={timeline === true ? "body-bold colour-tertiary block-text text-align-center" : "body-bold colour-primary block-text text-align-center"}>
                            Which strategy do you think is more
                            {
                                timeline === false ?
                                <br />
                                :
                                " "
                            }
                            appropriate given the context?
                        </span>
                    </div>
                    <div className="chat-action-required-chips-row">
                        <SelectionChip
                            label={"Optimistic"}
                            selected={false}
                            disabled={false}
                            func={() => selectScenario(true)}
                            index={0}
                            leftIcon={null}
                            rightIcon={null}
                        />
                        <SelectionChip
                            label={"Conservative"}
                            selected={false}
                            disabled={false}
                            func={() => selectScenario(false)}
                            index={0}
                            leftIcon={null}
                            rightIcon={null}
                        />
                    </div>
                </div>
            }
        </div>
    );
}

export default ChatActionRequired;